// Jela paketa i iznos za naplatu na kasi (modul više restorana).
//
// Uz skeniranog radnika server šalje:
//   order-more-restaurant[].order_guest_more_transactions[].addons   izabrana jela paketa, [{ name, quantity }]; količina je za jedan paket
//   collect_payment     true = radnik plaća na kasi; false = iznos se ne prikazuje (ni 0)
//   amount_to_collect   ukupno za naplatu, currency = valuta
// Čiste funkcije, bez Vue-a: dijele ih ekran v4 i stara stranica (canteen-testing), a mogu se provjeriti u Nodeu.

const isTrue = (v) =>
  v === true || v === 1 || v === "1" || (typeof v === "string" && v.trim().toLowerCase() === "true");

// 2650, "2650", "2650.00", "2650,50" → broj; sve drugo (prazno, tekst, negativno) → null
function toAmount(v) {
  if (typeof v === "number") return Number.isFinite(v) && v >= 0 ? v : null;
  if (typeof v !== "string") return null;
  const s = v.trim().replace(",", ".");
  return /^\d+(\.\d+)?$/.test(s) ? Number(s) : null;
}

// Izabrana jela paketa jedne stavke: [{ name, quantity }]. Bez imena ili s količinom 0 preskače se (nije izabrano).
export function readAddons(transaction) {
  const list = transaction && Array.isArray(transaction.addons) ? transaction.addons : [];
  const out = [];
  list.forEach((a) => {
    const raw = typeof a === "string" ? { name: a } : a;
    const name = raw && typeof raw.name === "string" ? raw.name.trim() : "";
    if (!name) return;
    const quantity = raw.quantity == null || raw.quantity === "" ? 1 : Number(raw.quantity);
    if (!(quantity > 0)) return;
    out.push({ name, quantity: Math.floor(quantity) || 1 });
  });
  return out;
}

// Redovi narudžbe kako ih kasa prikazuje. Izbori paketa su jela unutar paketa (addons), ne zasebni obroci:
// ako ih server ipak pošalje kao redove (line_type "choice" ili parent_id), preskaču se, a ako paket nema
// addons, uzimaju se iz tih redova. Bez takvih redova vraća ulaz nepromijenjen.
export function packageRows(transactions) {
  const list = Array.isArray(transactions) ? transactions : [];
  const isChild = (t) => !!t && (t.line_type === "choice" || (t.parent_id != null && t.parent_id !== 0));
  if (!list.some(isChild)) return list;
  return list
    .filter((t) => !isChild(t))
    .map((t) => {
      if (readAddons(t).length) return t;
      const children = list.filter((c) => isChild(c) && c.parent_id === t.id);
      if (!children.length) return t;
      return {
        ...t,
        addons: children.map((c) => ({ name: (c.meals || c.food || {}).name || c.name, quantity: c.quantity })),
      };
    });
}

// "Šakšuka" ili "2× Šakšuka"; convert je pretvaranje pisma (ćirilica u latinicu) koje stranica već koristi za nazive jela
export function addonText(addon, convert = (s) => s) {
  const name = convert(addon.name);
  return addon.quantity > 1 ? `${addon.quantity}× ${name}` : name;
}

// "Šakšuka, 2× Pileća supa"
export function addonsText(addons, convert) {
  return (Array.isArray(addons) ? addons : []).map((a) => addonText(a, convert)).join(", ");
}

// Iznos za naplatu: samo kad server kaže collect_payment = true (i pošalje iznos), inače null i ništa se ne prikazuje.
export function readPayment(d) {
  if (!d || !isTrue(d.collect_payment)) return null;
  const amount = toAmount(d.amount_to_collect);
  if (amount == null) return null;
  return { amount, currency: typeof d.currency === "string" ? d.currency.trim() : "" };
}

// 2650 → "2650", 1250.5 → "1250,50" ("1250.50" za en i zh); bez razmaka među hiljadama, kao u "2650 DIN"
export function formatAmount(amount, locale) {
  const cents = Math.round(amount * 100);
  const s = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
  return /^(en|zh)(-|$)/.test(String(locale || "")) ? s : s.replace(".", ",");
}

// "2650 DIN"
export function paymentText(pay, locale) {
  return pay ? [formatAmount(pay.amount, locale), pay.currency].filter(Boolean).join(" ") : "";
}
